import React from 'react'
import {
  Button,
  ButtonToolbar,
  Image,
  OverlayTrigger,
  ProgressBar,
  Table,
  Tooltip
} from 'react-bootstrap'
import moment from 'moment'
import SpinnerLoading from '../../../spinner-loading'
import cancelImg from '../../../../images/Cancel.svg'
import detailImg from '../../../../images/Detail.svg'
import cancelImg2 from '../../../../images/Cancel2.svg'
import { EMP_CHECK_LIST_NEW } from '../../../../router/routes'
import { Link, createSearchParams } from 'react-router-dom'
import sortDown from '../../../../images/sort-down.svg'
import sortUp from '../../../../images/sort-up-alt.svg'
import {
  BsFill1CircleFill,
  BsFill2CircleFill,
  BsFill4CircleFill,
  BsFill5CircleFill,
  BsFillCheckCircleFill
} from 'react-icons/bs'
export default function TableListNew({
  dataChecklist,
  page,
  totalLimits,
  isLoading,
  fnCancelCLN,
  orgId,
  sortDoc,
  sortCode,
  sortStartDate,
  sortName,
  handleSortDoc,
  handleSortCode,
  handleSortStartDate,
  handleSortName,
  clickedColumn
  // newMenu
}) {
  return (
    <div className="overflow-auto">
      <Table hover className="mb-3 ">
        <thead
          className="bg-hrms text-white "
          style={{ position: 'sticky', top: '0px', zIndex: 10 }}
        >
          <tr className="font-title-table">
            <th className="fw-normal " style={{ whiteSpace: 'nowrap' }}>
              #
            </th>
            <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
              {clickedColumn === 'clnNo' ? (
                <span
                  style={
                    clickedColumn === 'clnNo'
                      ? {
                          borderRadius: '2px',
                          border: '1px solid black',
                          padding: 2,
                          marginRight: 2
                        }
                      : {}
                  }
                >
                  <Image
                    className="fw-normal pointer-event"
                    src={sortDoc ? sortDown : sortUp}
                    onClick={() => handleSortDoc('clnNo')}
                  />
                </span>
              ) : (
                <Image
                  className="fw-normal pointer-event"
                  src={sortUp}
                  onClick={() => handleSortDoc('clnNo')}
                />
              )}
              Doc No.
            </th>
            <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
              {clickedColumn === 'code' ? (
                <span
                  style={
                    clickedColumn === 'code'
                      ? {
                          borderRadius: '2px',
                          border: '1px solid black',
                          padding: 2,
                          marginRight: 2
                        }
                      : {}
                  }
                >
                  <Image
                    className="pointer-event"
                    src={sortCode ? sortDown : sortUp}
                    onClick={() => handleSortCode('code')}
                  />
                </span>
              ) : (
                <Image
                  className="fw-normal pointer-event"
                  src={sortUp}
                  onClick={() => handleSortDoc('code')}
                />
              )}
              Code
            </th>
            <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
              {clickedColumn === 'startDate' ? (
                <span
                  style={
                    clickedColumn === 'startDate'
                      ? {
                          borderRadius: '2px',
                          border: '1px solid black',
                          padding: 2,
                          marginRight: 2
                        }
                      : {}
                  }
                >
                  <Image
                    className="pointer-event"
                    src={sortStartDate ? sortDown : sortUp}
                    onClick={() => handleSortStartDate('startDate')}
                  />
                </span>
              ) : (
                <Image
                  className="fw-normal pointer-event"
                  src={sortUp}
                  onClick={() => handleSortDoc('startDate')}
                />
              )}
              Start Date
            </th>
            <th
              className="fw-normal"
              style={{ whiteSpace: 'nowrap', minWidth: 120 }}
            >
              {clickedColumn === 'name' ? (
                <span
                  className="pointer-event"
                  style={
                    clickedColumn === 'name'
                      ? {
                          borderRadius: '2px',
                          border: '1px solid black',
                          padding: 2,
                          marginRight: 2
                        }
                      : {}
                  }
                >
                  <Image
                    className="pointer-event"
                    src={sortName ? sortDown : sortUp}
                    onClick={() => handleSortName('name')}
                  />
                </span>
              ) : (
                <Image
                  className="fw-normal pointer-event"
                  src={sortUp}
                  onClick={() => handleSortDoc('name')}
                />
              )}
              Name
            </th>
            <th
              className="fw-normal text-center"
              style={{ whiteSpace: 'nowrap' }}
            >
              Department{/* แผนก */}
            </th>
            <th
              className="fw-normal"
              style={{ whiteSpace: 'nowrap', minWidth: '200px' }}
            >
              Position {/* ตำแหน่ง */}
            </th>
            <th
              className="fw-normal text-center"
              style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
            >
              <div className="fw-bold text-center">01</div>
              <div className="fw-light small">
                {' '}
                PD {/* การเตรียมความพร้อมด้านอุปกรณ์ IT */}
              </div>
            </th>{' '}
            <th
              className="fw-normal text-center"
              style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
            >
              <div className="fw-bold text-center">02</div>
              <div className="fw-light small">
                {' '}
                IT Asset {/* การเตรียมความพร้อมด้านอุปกรณ์ IT */}
              </div>
            </th>{' '}
            <th
              className="fw-normal text-center"
              style={{ whiteSpace: 'nowrap', minWidth: '200px' }}
            >
              <div className="fw-bold text-center">03</div>
              <div className="fw-light small">
                IT
                {/* การเตรียมความพร้อมด้านระบบ IT{' '} */}
              </div>
            </th>{' '}
            <th
              className="fw-normal text-center"
              style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
            >
              <div className="fw-bold text-center">04</div>
              <div className="fw-light small"> ปฐมนิเทศ </div>
            </th>{' '}
            <th
              className="fw-normal text-center"
              style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
            >
              <div className="fw-bold text-center">05</div>
              <div className="fw-light small">
                {/* ผู้จัดการแผนกต้นสังกัด */}Manager
              </div>
            </th>{' '}
            <th
              className="fw-normal text-center"
              style={{ whiteSpace: 'nowrap' }}
            >
              Status
            </th>{' '}
            <th
              className="fw-normal text-center"
              style={{ whiteSpace: 'nowrap' }}
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {dataChecklist.length > 0 ? (
            dataChecklist.map((d, i) => (
              <tr key={i} className="fw-light font-small-2 ">
                <td> {page * totalLimits - totalLimits + i + 1}</td>
                <td className="">{d.cln_no}</td>
                <td className="">{d.code}</td>
                <td className="text-center ">
                  {d.start_date
                    ? moment(d.start_date).format('DD/MM/YYYY')
                    : '-'}
                </td>
                <td className="">
                  <p className="mb-0  ">
                    {d.title_th}
                    {d.name_th} {d.surname_th}
                  </p>
                </td>

                <td className=" text-center">{d.department}</td>

                <td className="">
                  {' '}
                  <p className="mb-0  ">{d.position_th} </p>
                </td>
                {/* step 1 PD */}
                <td className="text-center align-middle">
                  {d.step_id > 0 ? (
                    <BsFillCheckCircleFill
                      color={d.step_id < 0 ? '#bebebe' : '#0075ff'}
                      size={25}
                    />
                  ) : (
                    <BsFill1CircleFill
                      color={d.step_id >= 0 ? '#0075ff' : '#bebebe'}
                      size={25}
                    />
                  )}
                </td>
                {/* step 2 IT Asset (New) */}
                <td className="text-center align-middle">
                  {d.step_id === 5 ? (
                    <BsFill2CircleFill color={'#0075ff'} size={25} />
                  ) : d.step_id !== 5 && d.step_id > 0 ? (
                    <BsFillCheckCircleFill color={'#0075ff'} size={25} />
                  ) : d.step_id === 0 ? (
                    <BsFill2CircleFill color={'#bebebe'} size={25} />
                  ) : null}
                </td>
                {/* step 3 IT */}
                <td className="text-center small fw-light">
                  <p className="mb-0">
                    {d.is_confirm2_1 +
                      d.is_confirm2_2 +
                      d.is_confirm2_3 +
                      d.is_confirm2_4}
                    /4
                  </p>
                  <div className="text-center align-middle">
                    <ProgressBar
                      className="w-100"
                      style={{
                        gap: '0.5px'
                      }}
                    >
                      {d.status_id === 3 && d.is_confirm2_1 === 0 ? (
                        <ProgressBar
                          className={`border`}
                          style={{
                            backgroundColor: '#E9ECEF'
                          }}
                          now={25}
                          key={1}
                        />
                      ) : d.status_id === 3 && d.is_confirm2_1 !== 0 ? (
                        <ProgressBar className={`border`} now={25} key={1} />
                      ) : d.is_confirm2_1 === 0 ? (
                        <ProgressBar
                          className={`border`}
                          style={{
                            backgroundColor: '#E9ECEF'
                          }}
                          disabled={d.status_id === 3 ? true : false}
                          now={25}
                          key={1}
                        />
                      ) : (
                        <ProgressBar className="border" now={25} key={1} />
                      )}

                      {d.status_id === 3 && d.is_confirm2_2 === 0 ? (
                        <ProgressBar
                          className={`border`}
                          style={{
                            backgroundColor: '#E9ECEF'
                          }}
                          now={25}
                          key={2}
                        />
                      ) : d.status_id === 3 && d.is_confirm2_2 !== 0 ? (
                        <ProgressBar className={`border`} now={25} key={2} />
                      ) : d.is_confirm2_2 === 0 ? (
                        <ProgressBar
                          className="border"
                          style={{
                            backgroundColor: '#E9ECEF'
                          }}
                          now={25}
                          key={2}
                        />
                      ) : (
                        <ProgressBar className="border" now={25} key={2} />
                      )}

                      {d.status_id === 3 && d.is_confirm2_3 === 0 ? (
                        <ProgressBar
                          className={`border`}
                          style={{
                            backgroundColor: '#E9ECEF'
                          }}
                          now={25}
                          key={3}
                        />
                      ) : d.status_id === 3 && d.is_confirm2_3 !== 0 ? (
                        <ProgressBar className={`border`} now={25} key={3} />
                      ) : d.is_confirm2_3 === 0 ? (
                        <ProgressBar
                          className={`border`}
                          style={{
                            backgroundColor: '#E9ECEF'
                          }}
                          disabled={d.status_id === 3 ? true : false}
                          now={25}
                          key={3}
                        />
                      ) : (
                        <ProgressBar className="border" now={25} key={3} />
                      )}

                      {d.status_id === 3 && d.is_confirm2_4 === 0 ? (
                        <ProgressBar
                          className={`border`}
                          style={{
                            backgroundColor: '#E9ECEF'
                          }}
                          now={25}
                          key={4}
                        />
                      ) : d.status_id === 3 && d.is_confirm2_4 !== 0 ? (
                        <ProgressBar className={`border`} now={25} key={3} />
                      ) : d.is_confirm2_4 === 0 ? (
                        <ProgressBar
                          className={`border`}
                          style={{
                            backgroundColor: '#E9ECEF'
                          }}
                          disabled={d.status_id === 3 ? true : false}
                          now={25}
                          key={4}
                        />
                      ) : (
                        <ProgressBar className="border" now={25} key={4} />
                      )}
                    </ProgressBar>
                  </div>
                </td>

                {/* step 4 ปฐมนิเทศ */}
                <td className="text-center align-middle">
                  <div className="my-auto">
                    {d.step_id > 2 && d.step_id !== 5 ? (
                      <>
                        <BsFillCheckCircleFill
                          color={d.step_id < 2 ? '#bebebe' : '#0075ff'}
                          size={25}
                        />
                      </>
                    ) : (
                      <>
                        <BsFill4CircleFill
                          color={
                            d.is_confirm3 === 1 &&
                            d.is_confirm3_2 === 0 &&
                            d.step_id >= 2
                              ? '#ffb900'
                              : d.step_id >= 2 &&
                                d.is_confirm3 === 1 &&
                                d.is_confirm3_2 === 0
                              ? '#0075ff'
                              : '#bebebe'
                          }
                          size={25}
                        />
                      </>
                    )}
                  </div>
                </td>
                {/* step 5 Manager */}
                <td className="text-center align-middle">
                  <div style={{ width: '80%' }} className="my-auto"></div>
                  <div className="my-auto">
                    {d.step_id > 3 && d.step_id !== 5 ? (
                      <BsFillCheckCircleFill
                        color={
                          d.step_id < 3 && d.step_id !== 5
                            ? '#bebebe'
                            : '#0075ff'
                        }
                        size={25}
                      />
                    ) : (
                      <BsFill5CircleFill
                        color={
                          d.step_id >= 3 && d.step_id !== 5
                            ? '#0075ff'
                            : '#bebebe'
                        }
                        size={25}
                      />
                    )}
                  </div>
                </td>

                <td className="">
                  {d.status_id === 1 ? (
                    <span className="text-warning">Waitting</span>
                  ) : d.status_id === 2 ? (
                    <span className="text-success"> Success</span>
                  ) : d.status_id === 3 ? (
                    <span className="text-danger"> Cancel</span>
                  ) : null}
                </td>
                <td className="text-center ">
                  <div className="d-flex justify-content-center">
                    <ButtonToolbar>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-detail">Detail</Tooltip>}
                      >
                        <Link
                          to={`${EMP_CHECK_LIST_NEW}/stap-${
                            d.step_id > 4
                              ? 1
                              : d.step_id > 3
                              ? 4
                              : d.step_id > 2
                              ? 4
                              : d.step_id > 1
                              ? 3
                              : d.step_id > 0
                              ? 2
                              : d.step_id
                          }?${createSearchParams({
                            code: d.code,
                            org: orgId,
                            id: d.cln_no,
                            // stap: d.step_id > 3 ? 4 : d.step_id,
                            stap:
                              d.step_id > 4
                                ? 1
                                : d.step_id > 3
                                ? 4
                                : d.step_id > 2
                                ? 4
                                : d.step_id > 1
                                ? 3
                                : d.step_id > 0
                                ? 2
                                : d.step_id,
                            status: 1
                          })}`}
                          variant="btn btn-outline-primary"
                          className="border-0 d-flex justify-content-center"
                          size="sm"
                          style={{
                            width: '32px',
                            height: '32px'
                          }}
                        >
                          <Image
                            src={detailImg}
                            style={{
                              width: '20px'
                            }}
                          />
                        </Link>
                      </OverlayTrigger>
                    </ButtonToolbar>
                    {d.status_id === 1 ? (
                      <ButtonToolbar>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-detail">Cancel</Tooltip>
                          }
                        >
                          <Button
                            variant="btn btn-outline-primary"
                            className="border-0 d-flex justify-content-center"
                            size="sm"
                            style={{
                              width: '32px',
                              height: '32px'
                            }}
                            onClick={() => fnCancelCLN(d)}
                          >
                            <Image
                              src={cancelImg}
                              style={{
                                width: '20px'
                              }}
                            />
                          </Button>
                        </OverlayTrigger>
                      </ButtonToolbar>
                    ) : d.status_id === 2 ? (
                      <>
                        <Button
                          variant="btn btn-outline-primary"
                          className="border-0 d-flex justify-content-center"
                          size="sm"
                          style={{
                            width: '32px',
                            height: '32px'
                          }}
                          disabled
                        >
                          <Image
                            src={cancelImg2}
                            style={{
                              width: '20px'
                            }}
                          />
                        </Button>
                      </>
                    ) : d.status_id === 3 ? (
                      <>
                        <Button
                          variant="btn btn-outline-primary"
                          className="border-0 d-flex justify-content-center"
                          size="sm"
                          style={{
                            width: '32px',
                            height: '32px'
                          }}
                          disabled
                          onClick={() => fnCancelCLN(d)}
                        >
                          <Image
                            src={cancelImg2}
                            style={{
                              width: '20px'
                            }}
                            className="text-grey"
                          />
                        </Button>
                      </>
                    ) : null}
                  </div>
                </td>
              </tr>
            ))
          ) : !orgId ? (
            <tr className="mb-0">
              <td className="text-center small" colSpan={13}>
                - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
              </td>
            </tr>
          ) : isLoading ? (
            <tr className="mb-0">
              <td className="text-center" colSpan={13}>
                <SpinnerLoading />
              </td>
            </tr>
          ) : (
            <tr className="mb-0">
              <td className="text-center" colSpan={13}>
                -ไม่มีข้อมูล-
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  )
}
